
// * ========================================================================
// * totalPerRegion chart
// * ========================================================================

import CovidChart from './covid-chart.js';

const totalPerRegion = (function(){
    let thisChart = null;
    let dataType = null;
    let typeSelectors = null;
    const typeSelectorClass = 'input[name=area-total-chart-data]';
    let chartData = null;

    function createChartData(data, options) {
        // If data begins at selected date, get the first day values for each area
        const firstDayString = options.firstDate.format('YYYY-MM-DD');
        const areaData = dataType === 'date' && data.firstDayCounts && typeof data.firstDayCounts[firstDayString] !== 'undefined' ? data.firstDayCounts[firstDayString].areas : null;
        const rateString = 'rate_' + window.config.rateDays;
        const datasets = data.areas.map(function(item, index) {
            const count = dataType === 'rate' ? item[rateString] : areaData ? item.totalCount - areaData[item.id].firstDayCount : item.totalCount;

            return {
                id: item.id,
                label: item.name,
                name: item.name,
                selected: true,
                data: [count],
                count: count,
                backgroundColor: options.chartColors[index],
                barPercentage: 0.95,
                categoryPercentage: 0.99
            }
        }).sort(function(a, b) {
            return a.count < b.count ? 1 : -1;
        });

        return datasets;
    }

    function getYAxesLabel() {
        let label = 'Tartuntojen kokonaismäärä';
        if (dataType === 'date') {
            label = 'Uusien tartuntojen määrä'
        } else if (dataType === 'rate') {
            label = 'Ilmaantuvuus 100 000 asukasta kohden';
        }
        return label;
    }

    function getDataType() {
        dataType = document.querySelector(typeSelectorClass+':checked').value;
        return dataType;
    }

    /**
     * Initialize
     *
     * @param {Object} data - covid data
     */
    function init(data) {
        chartData = data;

        typeSelectors = document.querySelectorAll(typeSelectorClass);

        // Get the data type we want to show
        getDataType();

        const datasets = createChartData(chartData, window.config);
        const yAxesLabel = getYAxesLabel();

        thisChart = new CovidChart('area-total-chart', {
            datasets,
            chartOptions: {
                type: 'bar',
                options: {
                    plugins: {
                        legend: {
                            display: true
                        },
                        tooltip: {
                            mode: 'nearest',
                            enabled: true,
                            callbacks: {
                                title: function() {
                                    return '';
                                }
                            }
                        },
                    },
                    scales: {
                        y: {
                            title: {
                                display: true,
                                text: yAxesLabel
                            }
                        },
                        x: {
                            display: false,
                            type: 'category',
                            labels: [' ']
                        }
                    }
                }
            },
            config: window.config,
            multiselect: {
                requireCount: true,
                valueType: 'string',
                idField: 'id',
                colorField: 'backgroundColor',
                inputName: 'area-total-multiselect',
                selectElemId: 'area-total-multiselect',
                colorElemId: 'area-total-multiselect-colors',
                countElemId: 'area-total-multiselect-count',
                selectAllElemId: 'area-total-multiselect-select-all',
                clearAllElemId: 'area-total-multiselect-clear-all'
            },
            responsive: ['aspectRatio', 'legend']
        });

        // Create listener for type change
        typeSelectors.forEach((typeSelector) => {
            typeSelector.addEventListener('change', () => {
                let newType = document.querySelector(typeSelectorClass+':checked').value;
                if (dataType !== newType) {
                    reload(null, true);
                }
            });
        });
    }

    function reload(data = null, changeType = false) {
        if (data) {
            chartData = data;
        }

        // We need to reload only if the user wants to show data from specific date
        // Or the data type has changed
        const type = getDataType();
        if (changeType || (type === 'date' || type === 'rate')) {

            // Update data
            const datasets = createChartData(chartData, window.config);

            // Update yAxes label based on type
            thisChart.chart.options.scales.y.title.text = getYAxesLabel();

            // Update datasets
            thisChart.updateDatasets(datasets, true);
        }
    }

    return {
        init,
        reload
    }

})();

export default totalPerRegion;
